import React from "react";
import { Link } from "react-router-dom";
import {
  Monitor,
  Wifi,
  ShieldCheck,
  HardDrive,
  Laptop,
  Headphones,
  ArrowRight,
} from "lucide-react";
import { services } from "../mock";
import { Reveal } from "../hooks/useReveal";

const iconMap = { Monitor, Wifi, ShieldCheck, HardDrive, Laptop, Headphones };

const ServicesGrid = ({ compact = false, compactHome = false }) => {
  return (
    <section className="py-16 bg-neutral-50">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10">
        {!compact && (
          <div className="max-w-2xl mb-10">
            <p className="text-sm tracking-[0.3em] uppercase text-neutral-500 mb-3">
              — Ook incidentele reparaties
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-3 leading-tight">
              Alleen een eenmalig <span className="italic font-light">probleem?</span>
            </h2>
            <p className="text-base text-neutral-600 leading-relaxed">
              Geen abonnement nodig? Wij helpen u ook prima met een eenmalige reparatie of storing —
              transparant, snel en met dezelfde kwaliteit.
            </p>
          </div>
        )}

        {compactHome ? (
          /* Compact 6-column icon list, visually lighter than IT Support cards */
          <>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 bg-white border border-neutral-200 p-4">
              {services.map((service) => {
                const Icon = iconMap[service.icon];
                return (
                  <Link
                    to="/diensten"
                    key={service.id}
                    className="group flex flex-col items-center text-center p-4 hover:bg-neutral-50 transition-colors"
                  >
                    <div className="w-10 h-10 flex items-center justify-center mb-3 rounded-full border border-neutral-200 group-hover:border-neutral-900 transition-colors">
                      <Icon size={18} className="text-neutral-700 group-hover:text-neutral-900 transition-colors" />
                    </div>
                    <h3 className="text-[13px] font-semibold text-neutral-900 leading-tight">
                      {service.title}
                    </h3>
                  </Link>
                );
              })}
            </div>
            <div className="mt-5 text-center">
              <Link to="/diensten" className="inline-flex items-center gap-2 text-sm font-medium text-neutral-900 border-b border-neutral-900 pb-0.5 hover:gap-3 transition-all">
                Bekijk onze reparatieservice in Beverwijk →
              </Link>
            </div>
          </>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 border-l border-t border-neutral-200 bg-white">
            {services.map((service, idx) => {
              const Icon = iconMap[service.icon];
              return (
                <Reveal
                  key={service.id}
                  delay={idx * 70}
                  className="group p-8 border-r border-b border-neutral-200 hover:bg-neutral-900 transition-colors duration-300 relative"
                >
                  <div className="w-12 h-12 flex items-center justify-center mb-6 border border-neutral-300 group-hover:border-white transition-colors">
                    <Icon size={22} className="text-neutral-900 group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="text-xl font-semibold text-neutral-900 group-hover:text-white mb-3 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-neutral-600 group-hover:text-neutral-300 leading-relaxed mb-5 transition-colors text-[15px]">
                    {service.description}
                  </p>
                  <ul className="space-y-1.5 mb-6">
                    {service.features.map((f, i) => (
                      <li
                        key={i}
                        className="text-sm text-neutral-500 group-hover:text-neutral-400 flex items-center gap-2 transition-colors"
                      >
                        <span className="w-1 h-1 bg-neutral-400 group-hover:bg-white rounded-full"></span>
                        {f}
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/contact"
                    className="inline-flex items-center gap-2 text-sm font-medium text-neutral-900 group-hover:text-white transition-colors"
                  >
                    Meer informatie
                    <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
                  </Link>
                </Reveal>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default ServicesGrid;
